module.exports = __webpack_public_path__ + "img/yellow_circle.3f147eb4.png";